import { render, staticRenderFns } from "./VideoResumes.vue?vue&type=template&id=d57bdc38"
import script from "./VideoResumes.vue?vue&type=script&lang=js"
export * from "./VideoResumes.vue?vue&type=script&lang=js"
import style0 from "./VideoResumes.vue?vue&type=style&index=0&id=d57bdc38&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports